import { Component, ContentChildren, HostBinding, QueryList } from '@angular/core';
import { RadioComponent } from '@commons/controls/radio/radio.component';

@Component({
  templateUrl: './radio-group.component.html',
  selector: 'app-radio-group',
  styleUrls: ['./radio-group.component.scss'],
})
export class RadioGroupComponent {
  @HostBinding('class.radio-group') radioGroup = true;
  @ContentChildren(RadioComponent) radios: QueryList<RadioComponent>[];
}
